import Vue from 'vue'
import Vuex from 'vuex'

/* Importação dos módulos gerais */
import general from './modules/general'
import user from './modules/user'

/* Pagamentos */
import payment from "./modules/payment"
import chargeback from "./modules/chargeback"

import spreadsheets from './modules/spreadsheets'

/* Minhas Vendas */
import clients from './modules/minhas-vendas/clients'
import sales from './modules/minhas-vendas/sales'
import tickets from './modules/minhas-vendas/tickets'
import historics from './modules/minhas-vendas/historics'


/* App Authorize */
import app_authorize from './modules/app_authorize/app_authorize'

/* Calculadora */
import calculator from './modules/calculator/'

/* Signup screen */
import signup from './modules/signup/'

/* Meus envios */
import meusEnvios from './modules/meus-envios/';

/* Global Modal */
import modalV2 from './modules/modal-v2';


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    general,
    clients,
    sales,
    user,
    tickets,
    historics,
    payment,
    chargeback,
    spreadsheets,
    app_authorize,
    calculator,
    signup,
    meusEnvios,
    modalV2
  }
})
